import crypto from "crypto";

const algorithm = "aes-256-cbc"; // Algorithm used for encryption and decryption
const keyLength = 32; // Length of the key for AES-256
const ivLength = 16; // Length of the IV
const key = Buffer.from("bPZs8T20uC7ZVAYp/td3pKE5nYeqEnlASi+jCbL50bY=", "base64"); // 32 bytes
const iv = Buffer.from("0arlqccCSMoK8QDZrhuF7g==", "base64"); // 16 bytes
/**
 * Encrypts a string using AES-256-CBC.
 * @param {string} plaintext - The text to encrypt.
 * @param {string} key - A 32-byte encryption key.
 * @param {string} iv - A 16-byte initialization vector.
 * @returns {string} - The encrypted string in base64 format.
 */
export function encrypt(plaintext) {
  try {
    if (key.length !== keyLength || iv.length !== ivLength) {
      throw new Error(
        `Key must be ${keyLength} bytes and IV must be ${ivLength} bytes.`
      );
    }

    const cipher = crypto.createCipheriv(algorithm, Buffer.from(key), Buffer.from(iv));
    let encrypted = cipher.update(plaintext, "utf8", "base64");
    encrypted += cipher.final("base64");
    return encrypted;
  } catch (error) {
    throw new Error(`Encryption failed: ${error.message}`);
  }
}

/**
 * Decrypts a string using AES-256-CBC.
 * @param {string} ciphertext - The encrypted text in base64 format.
 * @param {string} key - A 32-byte decryption key.
 * @param {string} iv - A 16-byte initialization vector.
 * @returns {string} - The decrypted plaintext string.
 */
export function decrypt(ciphertext) {
  try {
    if (key.length !== keyLength || iv.length !== ivLength) {
      throw new Error(
        `Key must be ${keyLength} bytes and IV must be ${ivLength} bytes.`
      );
    }

    const decipher = crypto.createDecipheriv(algorithm, Buffer.from(key), Buffer.from(iv));
    let decrypted = decipher.update(ciphertext, "base64", "utf8");
    decrypted += decipher.final("utf8");
    return decrypted;
  } catch (error) {
    throw new Error(`Decryption failed: ${error.message}`);
  }
}